export var HighlightType;
(function (HighlightType) {
    HighlightType["Link"] = "LINK";
    HighlightType["Text"] = "TEXT";
})(HighlightType || (HighlightType = {}));
//# sourceMappingURL=Inspirational.types.js.map